import React from "react"

import { connect } from "scrivito"
import { ApiResponse } from "shared/types/ApiResponse"
import { ProductConfiguratorMode } from "shared/types/ProductConfiguratorMode"
import { RJSFFormContextProvider } from "shared/ui/rjsf-form/RJSFFormContext"

import { ProductConfiguratorResult } from "widgets/product-configurator/model/useProductConfiguratorModel"

import { ProductConfigurationOverlay } from "./ProductConfigurationOverlay"
import { useProductConfigurationOverlayModel } from "./hooks/useProductConfigurationOverlayModel"

export interface ProductConfigurationOverlayPayload {
  configuration: ProductConfiguratorResult
  mode?: ProductConfiguratorMode
  onSubmit?: (
    configuration: ProductConfiguratorResult
  ) => Promise<ApiResponse<unknown>> | void
}

export interface ProductConfigurationOverlayConnectorProps {
  payload: ProductConfigurationOverlayPayload
}

function ProductConfigurationOverlayConnectorComponentInner(
  props: ProductConfigurationOverlayConnectorProps
) {
  return (
    <ProductConfigurationOverlay
      {...useProductConfigurationOverlayModel(props)}
    />
  )
}

const ConnectedProductConfigurationOverlayConnectorComponentInner = connect(
  ProductConfigurationOverlayConnectorComponentInner
)

function ProductConfigurationOverlayConnectorComponent(
  props: ProductConfigurationOverlayConnectorProps
) {
  return (
    <RJSFFormContextProvider>
      <ConnectedProductConfigurationOverlayConnectorComponentInner {...props} />
    </RJSFFormContextProvider>
  )
}

export const ProductConfigurationOverlayConnector = React.memo(
  connect(ProductConfigurationOverlayConnectorComponent)
) as typeof ProductConfigurationOverlayConnectorComponent

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PRODUCT_CONFIGURATION_OVERLAY: ProductConfigurationOverlayPayload
  }
}
